import Image from 'next/image'
import LoginLink from '../LoginLink'

function LandingHeader(): JSX.Element {
  return (
    <header className="flex pt-10 mb-10">
      <div className="flex-1 flex z-10 max-h-9">
        <Image
          src="/assets/o_series/landing/logo.svg"
          width="208"
          height="36"
          alt="logo"
        />
      </div>
      <div className="flex-1">
        <div className="flex justify-end">
          <LoginLink />
        </div>
      </div>
    </header>
  )
}

export default LandingHeader
